import {lazy} from "react";
import {authRoles} from "app/auth/authRoles";

const AssistenteDigital = lazy(() => import("./AssistenteDigital"));

const assistenteDigitalRoute = [
    {
        path: "/collection-assistant",
        element: <AssistenteDigital/>,
        auth: authRoles.admin,
    },
];

export default assistenteDigitalRoute;